import { useSupportRequestForm } from '../hooks/useSupportRequestForm';
import { SupportRequestHeader } from './SupportRequestModal/SupportRequestHeader';
import { SupportRequestFormFields } from './SupportRequestModal/SupportRequestFormFields';

interface SupportRequestModalProps {
  isOpen: boolean;
  onClose: () => void;
  advisorEmail: string;
  advisorName: string;
  searchQuery?: string;
  locationZipCode?: string;
  locationState?: string;
  locationCounty?: string;
  locationAddress?: string;
}

const SupportRequestModal = ({
  isOpen,
  onClose,
  advisorEmail,
  advisorName,
  searchQuery = '',
  locationZipCode = '',
  locationState = '',
  locationCounty = '',
  locationAddress = '',
}: SupportRequestModalProps) => {
  const onSubmitRequest = async () => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    alert('Support request submitted successfully! We will get back to you soon.');
    onClose();
  };

  const {
    formData,
    isSubmitting,
    handleInputChange,
    handleRadioChange,
    handleCheckboxChange,
    handleSubmit,
  } = useSupportRequestForm({
    isOpen,
    advisorEmail,
    advisorName,
    searchQuery,
    locationAddress,
    locationCounty,
    locationState,
    locationZipCode,
    onSubmit: onSubmitRequest,
  });

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/25 backdrop-blur-sm px-4 py-4"
      style={{ fontFamily: '"Inter", sans-serif' }}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="relative w-full max-w-[700px] max-h-[90vh] rounded-lg bg-white border border-gray-300 shadow-lg flex flex-col">
        <SupportRequestHeader onClose={onClose} />
        <div className="flex-1 overflow-y-auto px-6 py-4">
          <form onSubmit={handleSubmit} className="space-y-4 text-[16px] md:text-[17px]">
            <SupportRequestFormFields
              formData={formData}
              onInputChange={handleInputChange}
              onRadioChange={handleRadioChange}
              onCheckboxChange={handleCheckboxChange}
            />
            <div className="flex justify-end pt-2">
              <button
                type="submit"
                disabled={isSubmitting}
                className="rounded-md bg-[#026857] px-6 py-2 text-base font-medium text-white transition-colors hover:bg-[#025247] disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SupportRequestModal;

